module.exports = __webpack_public_path__ + "img/cafe.cfc1e10e.png";